import { useCallback, useEffect, useRef } from "react";
import { useNotify } from "react-admin";
import { useHistory, useLocation } from "react-router-dom";

import { useParticipant } from "../../http";

export const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export const useAutoHideNotify = () => {
  const notify = useNotify();
  const timerRef = useRef(null);

  const showNotification = useCallback((message, type = 'info', duration = 5000) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    notify(message, type);

    timerRef.current = setTimeout(() => {
      timerRef.current = null;
    }, duration);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [notify]);

  return showNotification;
};

export const useFocusState = (focusKey, timeout = 4000, scrollTimeout = 750) => {
  const location = useLocation();
  const history = useHistory();
  const { focus, scrollTo } = location.state || {};

  useEffect(() => {
    if (focus !== focusKey || !timeout) return;

    const timer = setTimeout(() => {
      history.replace({ ...location, state: { ...location.state, focus: null, scrollTo: null } });
    }, timeout);

    return () => clearTimeout(timer);
  }, [focus, focusKey, location, history, timeout]);

  useEffect(() => {
    if (!scrollTo) return;
    const element = document.getElementById(scrollTo);
    if (element) {
      setTimeout(() => element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' }), scrollTimeout);
    }
  }, [scrollTimeout, scrollTo])

  return {
    focus,
    isFocused: focus === focusKey,
  };
};

export const useIsOwnParticipant = (participantId) => {
  const loggedInParticipantId = useParticipant();
  return participantId === loggedInParticipantId;
}
